import { FeatureEnrollment } from './FeatureEnrollment';
import { Instance } from '../../Utility/Instance';

export const features = new Instance<FeatureEnrollment>();
